// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__tl93L","active":"Modal_active__XYakP","dark":"Modal_dark__8NVIe","light":"Modal_light__BxeLp","modal-alt-exit":"Modal_modal-alt-exit__09Qjt"};